import styled from 'styled-components';

export const RowLine = styled.section`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  p {
    margin-right: 1rem;
  }
  span {
    display: block;
  }
  .icontop {
    position: absolute;
    top: 5px;
    left: 5px;
  }
`;
export const SpanBlock = styled.span`
  display: block;
`;
export const ButtonsStyle = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;
